import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import classnames from 'classnames';
class MenuButton extends Component {
  componentDidMount() {

  }
  render() {
    //if(true || this.props.user.id) {
    return (<MenuTrigger {...this.props}/>)
    //}
    /*
    return (
      <Link className="btn-login" to="login"><img src={require('./images/sign.png')} alt="登录"/></Link>
    )
    */
  }
}

class MenuTrigger extends Component {

  componentDidMount() {}

  render() {
    const {router} = this.props

    return (
      <div className="header">
        <div>
          <a href="https://www.chinatopcredit.com/" className="logo"><img src={require('./images/logo.png')} width="169"/></a>
          <ul className="header-menu clearfix">
            <li className={classnames({'cur': router.location.pathname === '/'})} ><a href="/">首页</a></li>
            <li className={classnames('services', {'cur': router.location.pathname.indexOf("services") != -1 })}>
              <a href="#product" onClick={() => this.productDiv('product') }>产品与服务</a>
              <dl>
                <dd><a href="./services/huoke">智能获客</a></dd>
                <dd><a href="./services/fengkong">智能风控</a></dd>
                <dd><a href="./services/jiqiren">智能机器人</a></dd>
                <dd><a href="./services/automl">自动建模平台</a></dd>
                <dd><a href="./services/fangan">一站式信贷解决方案</a></dd>
              </dl>
            </li>
            <li className={classnames('services', {'cur': router.location.pathname.indexOf("aboutUs") != -1 && router.location.pathname.indexOf("news") != -1  })}>
              <a href="#news" onClick={() => this.productDiv('news') }>新闻中心</a>
            </li>
            <li><a href="#saas" onClick={() => this.productDiv('saas') }>海外SaaS服务</a></li>
            <li className={classnames({'cur': router.location.pathname.indexOf("aboutUs") != -1 && router.location.pathname.indexOf("news") == -1 })}><a href="./aboutUs/company">关于我们</a></li>
        </ul>
      </div>
    </div>
    )
  }


  productDiv(id){
    $("html, body").animate({
      scrollTop: $("#" + id ).offset().top }, {duration: 500,easing: "swing"});
    return false;
  }

}

const mapStateToProps = (state) => {
  return {
    menus: state.common.menus
  }
}
export default connect(mapStateToProps)(MenuButton)



// WEBPACK FOOTER //
// ./components/layout/MenuButton.js